// Search-panel schema for the IM Item Management "Item Master" tab. Field names match the load params the
// reused om/SaleOrder/GetItemMasterMain endpoint expects (see GetItemMasterMainGridData). First 8 fields
// are visible; the rest ride along hidden (visible:false) via the form's field chooser.
const f = (name, label, type, visible, options) => ({
  name, tableName: "", label, type, options: options || null, apiUrl: null, grid: null, required: false, visible,
});

const codes = (from, to) => {
  const out = [];
  for (let i = from; i <= to; i++) out.push(f(`UserDefinedCode${i}`, `Code - ${i}`, "text", false));
  return out;
};
const references = (from, to) => {
  const out = [];
  for (let i = from; i <= to; i++) out.push(f(`UserDefinedReference${i}`, `Reference - ${i}`, "text", false));
  return out;
};

const ItemMasterFormLayout = [
  {
    groupId: 1,
    label: "",
    fields: [
      f("WarehouseID", "Warehouse", "text", true),
      f("ItemCode", "Item", "text", true),
      f("ItemType", "Item Type", "select", false),
      f("InventoryUnitUom", "Inventory Unit", "text", false),
      ...codes(1, 3),
    ],
  },
  {
    groupId: 2,
    label: "",
    fields: [
      f("Description_1", "Description - 1", "text", true),
      f("Description_2", "Description - 2", "text", true),
      f("ItemSourceFlag", "Item Source", "select", false),
      f("CareInstructions", "Instructions", "text", false),
      ...codes(4, 7),
    ],
  },
  {
    groupId: 3,
    label: "",
    fields: [
      f("ClassCode", "Class", "text", true),
      f("SubClassCode", "Sub Class", "text", true),
      f("DateIntroduced", "Introduced Date", "date", false),
      f("DateAvailable", "Available Date", "date", false),
      f("DateExpiration", "Expiration Date", "date", false),
      ...codes(8, 10),
    ],
  },
  {
    groupId: 4,
    label: "",
    fields: [
      // Status is a descriptive dropdown (options injected in onFormLoad).
      f("Status", "Status", "select", true),
      f("AverageCost", "Average Cost", "number", false),
      f("LastCost", "Last Cost", "number", false),
      f("CreationUserId", "Created By", "text", false),
      ...references(1, 10),
    ],
  },
];

export default ItemMasterFormLayout;
